<template>
  <div
    ref="ref"
    class="t3m-ObjectiveFinder-scrollToTop"
    :style="`left: ${this.x}; top: ${this.y};`"
  >
    <transition appear leave name="fade">
      <div
        class="t3m-ObjectiveFinder-scrollToTop-inner"
        v-if="listOutOfView"
        @click="scrollIntoView"
      >
        To Top
      </div>
    </transition>
  </div>
</template>

<script>
import { utilities } from "../shared";
import { mapState, mapActions } from "vuex";
export default {
  name: "ScrollToTop",
  data() {
    return {
      x: Number,
      y: Number,
      scrollStart: 0,
    };
  },
  mounted() {
    const vm = this;
    window.addEventListener(
      "resize",
      function () {
        vm.setListOutOfView(false);
      },
      { passive: true }
    );
  },
  computed: {
    ...mapState(["listOutOfView", "lastFilterOption"]),
  },
  mixins: [utilities],
  methods: {
    ...mapActions(["setListOutOfView"]),

    handleScroll: function () {
      if (
        Math.abs(document.documentElement.scrollTop - this.scrollStart) > 100
      ) {
        document.removeEventListener("scroll", this.handleScroll, {
          passive: true,
        });
        this.setListOutOfView(false);
        this.scrollStart = 0;
      }
    },
  },
  watch: {
    listOutOfView: function () {
      if (this.listOutOfView) {
        this.x =
          this.$refs.ref.parentNode.getBoundingClientRect().left +
          this.$refs.ref.parentNode.getBoundingClientRect().width +
          16 +
          "px";
        this.y =
          this.lastFilterOption.$refs.ref.getBoundingClientRect().top + "px";
        this.scrollStart = document.documentElement.scrollTop;
        document.addEventListener("scroll", this.handleScroll, {
          passive: true,
        });
      }
    },
  },
};
</script>